// removed by extract-text-webpack-plugin
module.exports = {"marker":"map__marker__1tAc6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Map/map.css
// module id = 147
// module chunks = 0